/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */

import { SlugError } from '../console';
import { URLLike, searchBatchAppend } from '../url';
import { callPromise } from '../utils';
import { appendInHead, removeFromDom } from './_dom';

interface JSONPOptions {
  url: URLLike;

  callbackFnName?: string;
  data?: { [key: string]: string | number };
  timeout?: number;

  context?: any;
}

// jsonp 请求
export const jsonp = <T>({
  url,
  data = {},
  timeout = 3000,
  callbackFnName = 'callback',

  context = window,
}: JSONPOptions) => {
  const id = `sf_jsonp_${Number.parseInt(
    (Math.random() * 1000000).toString(),
    10,
  )}`;
  const urlWithData = searchBatchAppend(Object.assign(data, { [callbackFnName]: id }), url).toString();

  return callPromise({
    context,
    dataSource: (ctx: any) => new Promise<T>((resolve) => {
      const cb = (data: T) => {
        resolve(data);
      };
      (ctx as any)[id] = cb;
      const ele = document.createElement('script');
      console.log(ele);
      ele.setAttribute('src', urlWithData);
      appendInHead(ele);
      ctx.script = ele;
      ctx.cb = cb;
    }),
    timeout,
    timeoutError: new SlugError('jsonp timeout', urlWithData),
    cleanup: (ctx: any) => {
      delete (globalThis as any)[id];
      removeFromDom(ctx.script);
    },
  });
};

// TODO: jsonp used by sdk
// smart jsonp (auto web/sdk)
